export default class StsLink {

  href: string;
  target: string;
  title: string;
  type: string;
  cssClass: string;

}
